var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" Atribuir Perfil em Lote ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Perfil",
      "items": _vm.form.lists.perfis,
      "item-text": 'nome',
      "item-value": 'id',
      "rules": [function (v) {
        return _vm.$required(v);
      }],
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.content.perfil,
      callback: function ($$v) {
        _vm.$set(_vm.content, "perfil", $$v);
      },
      expression: "content.perfil"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list', [_c('v-subheader', [_vm._v("Nome dos Usuários")]), _vm._l(_vm.content.profissionais, function (profissional, i) {
    return _c('v-list-item', {
      key: i,
      attrs: {
        "value": profissional,
        "color": "primary",
        "variant": "plain"
      }
    }, [_c('v-list-item-title', [_c('v-icon', [_vm._v("mdi mdi-account")]), _vm._v(" " + _vm._s(profissional.nomeSocial || profissional.nome))], 1)], 1);
  })], 2)], 1)], 1)], 1) : _vm._e()], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }